import { render, staticRenderFns } from "./preset.vue?vue&type=template&id=688db530&scoped=true"
import script from "./preset.vue?vue&type=script&lang=js"
export * from "./preset.vue?vue&type=script&lang=js"
import style0 from "./preset.vue?vue&type=style&index=0&id=688db530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688db530",
  null
  
)

export default component.exports